import { ShieldCheck, ExternalLink } from "lucide-react";

export default function ConnectPanel({ connect, connecting, onStart }) {
  return (
    <section className="gold-frame paper-scroll rounded-sm p-6 sm:p-8 mb-14" data-testid="connect-panel">
      <div className="flex flex-wrap items-start justify-between gap-6">
        <div className="max-w-xl">
          <div className="flex items-center gap-2 mb-2">
            <ShieldCheck className="w-4 h-4 text-[#D9B472]" />
            <span className="text-[10px] uppercase tracking-widest text-[#D9B472] font-mono-brass">Stripe Connect · Real Payouts</span>
          </div>
          {connect?.payouts_enabled ? (
            <>
              <h3 className="font-serif-display text-2xl text-[#F7F3EC] mb-1">Payouts are live.</h3>
              <p className="text-sm text-[#A8A095] font-serif-body">Every withdrawal now sends real money to your bank via Stripe. Your legal identity is held privately by Stripe — buyers still see only your pen name.</p>
            </>
          ) : connect?.connected ? (
            <>
              <h3 className="font-serif-display text-2xl text-[#F7F3EC] mb-1">Finish Stripe onboarding.</h3>
              <p className="text-sm text-[#A8A095] font-serif-body">You've started onboarding. Complete the remaining steps to enable real bank payouts. Until then, withdrawals are recorded but simulated.</p>
            </>
          ) : (
            <>
              <h3 className="font-serif-display text-2xl text-[#F7F3EC] mb-1">Connect a bank for real payouts.</h3>
              <p className="text-sm text-[#A8A095] font-serif-body">Right now, withdrawing is simulated. Onboard with Stripe once and every future withdraw sends real money to your account — anonymously, under your pen name.</p>
              <p className="text-xs text-[#6E675E] font-mono-brass mt-3">
                Platform owner: if this errors, enable Connect at{" "}
                <a href="https://dashboard.stripe.com/test/settings/connect" target="_blank" rel="noreferrer" className="text-[#D9B472] underline" data-testid="connect-enable-link">dashboard.stripe.com/test/settings/connect</a>
                {" "}(one click).
              </p>
            </>
          )}
        </div>
        <button
          onClick={onStart}
          disabled={connecting}
          className={`px-6 py-3.5 rounded-sm font-mono-brass text-xs uppercase tracking-widest font-semibold inline-flex items-center gap-2 ${connect?.payouts_enabled ? "btn-ghost-gold" : "btn-buy"}`}
          data-testid="connect-onboard-button"
        >
          {connecting ? "Redirecting…" : connect?.payouts_enabled ? "Manage payout account" : connect?.connected ? "Finish onboarding" : "Onboard with Stripe"} <ExternalLink className="w-3.5 h-3.5" />
        </button>
      </div>
    </section>
  );
}
